// extracted by mini-css-extract-plugin
export default {"wrapper":"Vm-z","response":"Wm-z","error":"Xm-z","disabled":"Ym-z","buttons":"Zm-z","feedbackQuestionSection":"_m-z","yesNoWrapper":"an-z"};